import { render, staticRenderFns } from "./FileDropArea.vue?vue&type=template&id=0516ad12&scoped=true&lang=html&"
import script from "./FileDropArea.vue?vue&type=script&lang=js&"
export * from "./FileDropArea.vue?vue&type=script&lang=js&"
import style0 from "./FileDropArea.vue?vue&type=style&index=0&id=0516ad12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0516ad12",
  null
  
)

export default component.exports